import styled from "styled-components";

export const SelectsContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    gap: 1rem;
`;

export const SelectContainer = styled.div`
    width: 20em;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    margin-bottom: 2rem;
`;


export const SelectContainerNumbers = styled.div`
    width: fit-content;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    margin-bottom: 2rem;
    margin-right: 1rem;
    
    .select-box-number {
        width: 15em;
    }
`;

export const SelectContainers = styled.div`
    width: fit-content;
    display: flex;
    margin-bottom: 2rem;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;

    .select-box-number {
        width: 15em;
    } 
    
`;
export const Line = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;
    width: 2px; 
    height: 24px;
    background-color: var(--gray-light);
    border-radius: 1px;
`;
